import * as R from 'ramda';
import { createLogic } from 'redux-logic';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// feature dispatch-planner
import * as A from './actions';
import * as H from './helpers';
//////////////////////////////////////////////////

const hasLoadCloEvents = R.compose(
  R.not,
  R.isEmpty,
  R.filter((event) => R.not(R.isNil(event.cloGuid))),
);

export const handleRemoveTelFromRouteBuilder = createLogic({
  type: A.removeTelFromRouteBuilder,
  validate({ action }, allow, reject) {
    const tel = action.payload;

    if (hasLoadCloEvents(R.prop(GC.FIELD_LOAD_STOPS, tel))) {
      G.showToastrMessageSimple(
        'info',
        G.getWindowLocale('titles:cant-remove-tel-with-clo', 'Sorry, you can not remove TEL with CLO events'),
      );

      return reject();
    }

    allow(action);
  },
});

export const saveRoute = createLogic({
  type: A.validateRouteRequest,
  process({ action }, dispatch, done) {
    const validationData = H.validateRoute(action.payload.currentRoute);

    if (R.not(validationData.isValid)) {
      dispatch(A.setRouteErrors(validationData.errors));

      if (G.isTrue(validationData.noTels)) {
        G.showToastrMessageSimple(
          'error',
          G.getWindowLocale('validation:route-should-contain-tel', 'Route should contain at least one trip'),
        );
      }
    } else {
      dispatch(A.setRouteErrors(null));
      dispatch(A.saveRouteRequest(action.payload));
    }

    done();
  },
});

export default [
  saveRoute,
  handleRemoveTelFromRouteBuilder,
];
